import { Component, OnInit } from '@angular/core';
import { MensagemService } from "src/app/features/mensagem.service";
import { PermissaoService } from 'src/app/shared/permissao.service';
import { ROLE_GESTOR_ENVIO } from "src/app/constantes/permissao.constants";
import { CnaePermitidoService, CnaesPermitidosDTO, MascaraDto, NovoCnaePermitidoDTO } from '../../cnae-permitido.service';
import { ActivatedRoute, Router } from '@angular/router';

export interface CodigoCnaeDTO{
  codigo: string;
}

@Component({
    selector: 'app-novo-cnae-permitido',
    templateUrl: './novo-cnae-permitido.component.html',
    styleUrls: ['./novo-cnae-permitido.component.scss'],
    standalone: false
})
export class NovoCnaePermitidoComponent implements OnInit {
  ideTranche: number;
  tipoOperacaoSelect: any;
  objetivoFinanciamentoSelect: any;
  mascaras: MascaraDto[];
  codigosCnae: CodigoCnaeDTO[] = [];
  dataHoje = new Date();
  podeCadastrarEncerrar: boolean = false;
  listaCnaesForSave: NovoCnaePermitidoDTO[] = [];
  readonly MAX_ITENS: number = 10;

  constructor(
    private cnaePermitidoService: CnaePermitidoService,
    private mensagemService: MensagemService,
    private permissaoService: PermissaoService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.ideTranche = +this.activatedRoute.snapshot.paramMap.get('id')!;

    this.permissaoService.getPermissoesUsuarioAutenticado()
      .subscribe((resp: any) => {
        this.podeCadastrarEncerrar = resp && resp[ROLE_GESTOR_ENVIO];
      });
    
    this.tipoOperacaoSelect = [
      {label: 'R - Repasse BNDES', value: 'R'},
      {label: 'L - Crédito Livre', value: 'L'},
    ]

    this.objetivoFinanciamentoSelect = [
      {label: 'G - Empréstimo/Capital de Giro', value: 'G'},
      {label: 'I - Investimento', value: 'I'},
    ]

    this.dataHoje.setDate(this.dataHoje.getDate() + 1);
    this.carregarDados(); 
  }

  async carregarDados() {
    this.cnaePermitidoService.getMascaras().subscribe(response => {
      this.mascaras = response ? response.sort((a, b) => a?.mascara ? a.mascara.localeCompare(b.mascara) : 0) : null;
    });

    this.cnaePermitidoService.getCodigosCnae().subscribe(response => {
      this.codigosCnae = response;
    });

    this.adicionarLinha();
  }

  validarCamposObrigatorios(): boolean {
    return !this.listaCnaesForSave.some(item => !item.dataInicioValidade || !item.mascara);
  }

  limpar() {
    this.listaCnaesForSave = [];
  }

  async salvar() {
    if (this.validarCamposObrigatorios()) {
      let ideTranche = this.ideTranche;
      
      const cnaesPermitidosDTO: CnaesPermitidosDTO = {
        cnaesPermitidosDTO: this.listaCnaesForSave
      }

      try {
        await this.cnaePermitidoService.salvar(ideTranche, cnaesPermitidosDTO).toPromise();
        this.mensagemService.adicionarMensagemSucesso('Inclusão realizada com sucesso.');
        this.voltarTelaCnaesPermitidos();
      } catch (error) {
        this.mensagemService.adicionarMensagemErro('Erro ao tentar salvar novo(s) cnae(s) permitido(s).');
      }  
    }
  }

  adicionarLinha() {
    if (this.listaCnaesForSave.length < this.MAX_ITENS) { 
      this.listaCnaesForSave.push({
        dataInicioValidade: null,
        mascara: null,
        objetivoFinanciamento: null,
        tipoOperacao: null
      });
    } else {
      this.mensagemService.adicionarMensagemAviso("Você atingiu o limite máximo de 10 máscaras.");
    }
  }

  removerLinha(index: number) {
    this.listaCnaesForSave.splice(index, 1);
  }

  voltarTelaCnaesPermitidos() {
    this.limpar();
    this.router.navigate(['cnaes-permitidos']);
  }

}